import React, { FC, useContext, useMemo } from 'react';
import { Stack } from '@mui/material';

import { Card, TitleTypography, OutlinedButton, useWindowDimensions } from '@Iot-Bee/standard-web-library';

import { ChartContext } from '../context/ChartContext';
import { Box } from '@mui/material';
import { DevicesContext } from '../../../context/DevicesContext';

interface DeviceDataCellProps {
  title: string;
  value: string | number;
}

const DeviceDataCell: FC<DeviceDataCellProps> = ({ title, value, ...props }) => (
  <Stack direction="column" sx={{ mr: '60px', width: 'auto' }} {...props}>
    <TitleTypography>{title}</TitleTypography>
    <TitleTypography sx={{ color: '#111111', mt: '5px' }}>{value}</TitleTypography>
  </Stack>
);

function DeviceStatusCard() {
  const chartContext = useContext(ChartContext);
  const devicesContext = useContext(DevicesContext);

  if (!chartContext) {
    throw new Error('DeviceStatusCard must be used within a ChartContextProvider');
  }

  if (!devicesContext) {
    throw new Error('DeviceStatusCard must be used within a DevicesContextProvider');
  }

  const { updateData, deviceId } = chartContext;
  const { devices } = devicesContext;

  const device = useMemo(() => {
    if (!devices) {
      return null;
    }

    return devices.find((device) => device.id === deviceId);
  }, [devices, deviceId]);

  const { screenwidth } = useWindowDimensions();

  return (
    <Box sx={{ display: 'flex', flexFlow: 'row wrap', gap: '16px' }}>
      <Box sx={{ flex: 4, width: '100%' }}>
        {device === null || device === undefined ? (
          <div>
            <p>Something went wrong loading the device</p>
          </div>
        ) : (
          <Card
            title={`Device ${device.deviceName}`}
            headerActions={<OutlinedButton onClick={updateData}>Update data</OutlinedButton>}
          >
            <Stack direction="row" sx={{ p: screenwidth > 320 ? '20px' : '10px 20px' }}>
              <DeviceDataCell title="Status" value={device.status} />
              <DeviceDataCell title="Data usage" value={device.dataUsage} />
              <DeviceDataCell title="Id" value={device.id} />
            </Stack>
          </Card>
        )}
      </Box>
    </Box>
  );
}

export default DeviceStatusCard;
